/* Kickslab Shopify theme — cart drawer, add-to-cart, predictive search, size guide */
/* i18n: strings injected from Liquid into window.KS.t (see layout/theme.liquid); fallback = PL */
window.KSt = function (k, fb) { return (window.KS && KS.t && KS.t[k]) || fb || ''; };
/* Language ⇒ currency coupling: PL keeps PLN, every other language defaults to an EUR country.
   Picks the best-matching available EUR country per language, falls back to the first one.
   The customer can still override currency manually via the currency selector. */
window.KSlangChange = function (sel) {
  var loc = sel.value, cc = '';
  if (loc === 'pl') {
    cc = (window.KS && KS.plCountry) || 'PL';
  } else {
    var list = (window.KS && KS.eurCountries) || [];
    var pref = ({ de: ['DE', 'AT'], nl: ['NL', 'BE'], en: ['IE', 'NL', 'DE', 'AT'] })[loc] || [];
    for (var i = 0; i < pref.length; i++) { if (list.indexOf(pref[i]) >= 0) { cc = pref[i]; break; } }
    if (!cc) cc = list[0] || '';
  }
  var inp = sel.form.querySelector('input[name=country_code]');
  if (inp && cc) inp.value = cc;
  sel.form.submit();
};
(function () {
  var selectedVariant = null;

  /* Format in the cart's presentment currency (EUR markets included), localized.
     cart.js returns `currency` (ISO) + prices in that currency's subunits. */
  function money(cents, cur) {
    cur = cur || (window.KS && KS.currency) || 'PLN';
    try {
      return new Intl.NumberFormat((window.KS && KS.locale) || 'pl', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' ' + cur;
    }
  }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  /* ---------- cart drawer ---------- */
  function renderCart(cart) {
    var d = document.getElementById('cart-drawer');
    var lines = cart.items.map(function (it, i) {
      var name = (it.product_title || '').replace(it.vendor, '').trim();
      return '<div class="cart-item"><div class="ci-img">' + (it.image ? '<img src="' + it.image + '" style="width:100%;height:100%;object-fit:contain">' : '') + '</div>' +
        '<div class="ci-info"><b>' + esc(it.vendor || '') + '</b> ' + esc(name) + '<br><span style="color:#888">' + KSt('size_word', 'Rozmiar') + ' ' + esc(it.variant_title || '') + '</span>' +
        '<div class="ci-row"><span class="qty"><button onclick="KSchg(\'' + it.key + '\',' + (it.quantity - 1) + ')">−</button><span>' + it.quantity + '</span><button onclick="KSchg(\'' + it.key + '\',' + (it.quantity + 1) + ')">+</button></span><b>' + money(it.final_line_price, cart.currency) + '</b></div>' +
        '<button class="ci-remove" onclick="KSchg(\'' + it.key + '\',0)">' + KSt('remove', 'Usuń') + '</button></div></div>';
    }).join('');
    d.innerHTML = '<div class="cart-head"><h3>' + KSt('cart_title', 'Koszyk') + ' (' + cart.item_count + ')</h3><button onclick="KScartClose()">×</button></div>' +
      (cart.item_count ? '<div class="cart-items">' + lines + '</div><div class="cart-foot"><div class="line total"><span>' + KSt('subtotal', 'Razem') + '</span><span>' + money(cart.total_price, cart.currency) + '</span></div><a class="btn btn-grad btn-block" style="margin-top:12px" href="/checkout">' + KSt('checkout', 'Przejdź do kasy') + '</a></div>'
        : '<div class="cart-empty"><p>' + KSt('empty', 'Twój koszyk jest pusty') + '</p><a class="btn btn-grad" href="' + (KS.routes.search || '/search') + '?q=*&type=product" onclick="KScartClose()">' + KSt('browse', 'Przeglądaj buty') + '</a></div>');
    var c = document.getElementById('cart-count'); if (c) c.textContent = cart.item_count;
  }
  window.KScartOpen = function () {
    var d = document.getElementById('cart-drawer'), o = document.getElementById('cart-overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
    fetch(KS.routes.cart + '.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  };
  window.KScartClose = function () {
    document.getElementById('cart-drawer').classList.remove('open');
    document.getElementById('cart-overlay').classList.remove('open');
  };
  window.KSchg = function (key, qty) {
    fetch(KS.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  };

  /* ---------- product: size + add ---------- */
  window.KSpickSize = function (el) {
    selectedVariant = el.getAttribute('data-id');
    document.querySelectorAll('#pdp-sizes .sz').forEach(function (x) { x.classList.remove('sel'); });
    el.classList.add('sel');
    document.getElementById('size-hint').textContent = '';
  };
  window.KSaddToCart = function () {
    if (!selectedVariant) { document.getElementById('size-hint').textContent = KSt('choose_size_hint', 'Wybierz rozmiar, aby dodać do koszyka.'); return; }
    var btn = document.getElementById('add-btn'); if (btn) btn.disabled = true;
    fetch(KS.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: selectedVariant, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function () { if (btn) btn.disabled = false; KScartOpen(); })
      .catch(function () { if (btn) btn.disabled = false; KScartOpen(); });
  };

  /* ---------- search suggestions (name + SKU) ---------- */
  window.KSsuggest = function (q) {
    var box = document.getElementById('search-suggest');
    q = (q || '').trim();
    if (q.length < 2) { box.classList.remove('open'); box.innerHTML = ''; return; }
    fetch(KS.routes.search + '?q=' + encodeURIComponent(q) + '&type=product&view=suggest&options[prefix]=last')
      .then(function (r) { return r.json(); })
      .then(function (items) {
        items = items || [];
        if (!items.length) { box.innerHTML = '<div class="ss-empty">' + KSt('no_results_for', 'Brak wynik\u00f3w dla \u201E%s\u201D').replace('%s', esc(q)) + '</div>'; box.classList.add('open'); return; }
        box.innerHTML = items.map(function (p) {
          var name = (p.title || '').replace(p.vendor || '', '').trim();
          return '<a class="ss-row" href="' + p.url + '"><div class="ss-img">' + (p.image ? '<img src="' + p.image + '" style="width:100%;height:100%;object-fit:contain">' : '') + '</div>' +
            '<div class="ss-info"><b>' + esc(p.vendor || '') + '</b> ' + esc(name) +
            '<br><span class="ss-price' + (p.onsale ? ' sale' : '') + '">' + esc(p.price) + '</span>' + (p.onsale && p.compare ? ' <s class="ss-old">' + esc(p.compare) + '</s>' : '') + '</div></a>';
        }).join('') + '<a class="ss-all" href="' + KS.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">Zobacz wszystkie wyniki \u2192</a>';
        box.classList.add('open');
      }).catch(function () { box.classList.remove('open'); });
  };

  /* ---------- size guide (per gender + brand) ---------- */
  var SIZE_TABLES = {
    men: [['38.5','5.5','6','24'],['39','6','6.5','24.5'],['40','6','7','25'],['40.5','6.5','7.5','25.5'],['41','7','8','26'],['42','7.5','8.5','26.5'],['42.5','8','9','27'],['43','8.5','9.5','27.5'],['44','9','10','28'],['44.5','9.5','10.5','28.5'],['45','10','11','29'],['45.5','10.5','11.5','29.5'],['46','11','12','30'],['47','12','13','31'],['48','13','14','32']],
    women: [['35.5','3','5','22'],['36','3.5','5.5','22.5'],['36.5','4','6','23'],['37.5','4.5','6.5','23.5'],['38','5','7','24'],['38.5','5.5','7.5','24.5'],['39','6','8','25'],['40','6.5','8.5','25.5'],['40.5','7','9','26'],['41','7.5','9.5','26.5'],['42','8','10','27']],
    gs: [['35.5','3','3.5Y','22'],['36','3.5','4Y','22.5'],['37','4','4.5Y','23'],['37.5','4.5','5Y','23.5'],['38','5','5.5Y','24'],['38.5','5.5','6Y','24.5'],['39','6','6.5Y','25'],['40','6.5','7Y','25.5']]
  };
  function brandFit(brand) {
    return ({
      'Nike': KSt('fit_nike', 'Nike zwykle pasuje standardowo; Air Force 1 i Dunk bywają nieco luźniejsze.'),
      'adidas': KSt('fit_adidas', 'adidas często pasuje standardowo; Samba i Gazelle są węższe — rozważ pół numeru większy.'),
      'New Balance': KSt('fit_nb', 'New Balance pasuje standardowo, dostępne także szersze kopyto.'),
      'ASICS': KSt('fit_asics', 'ASICS zwykle pasuje standardowo.'),
      'Salomon': KSt('fit_salomon', 'Salomon często pasuje nieco mniejszy — rozważ pół numeru większy.'),
      'On': KSt('fit_on', 'On zwykle pasuje standardowo; przy szerszej stopie rozważ pół numeru większy.'),
      'Saucony': KSt('fit_saucony', 'Saucony zwykle pasuje standardowo.')
    })[brand] || '';
  }
  window.KSsizeOpen = function (brand, gender) {
    gender = gender || 'men';
    var rows = SIZE_TABLES[gender] || SIZE_TABLES.men;
    var label = gender === 'women' ? KSt('size_women', 'Damskie') : (gender === 'gs' ? KSt('size_kids', 'Dziecięce (GS)') : KSt('size_men', 'Męskie'));
    var usHead = gender === 'gs' ? 'US (Y)' : 'US';
    var fit = brandFit(brand);
    var m = document.getElementById('sizeguide');
    m.innerHTML = '<div class="modal-head"><h3>' + KSt('size_heading', 'Rozmiary') + ' — ' + esc(brand || '') + ' · ' + label + '</h3><button onclick="KSsizeClose()">×</button></div>' +
      '<div class="modal-body"><table class="sizetable"><thead><tr><th>EU</th><th>UK</th><th>' + usHead + '</th><th>cm</th></tr></thead><tbody>' +
      rows.map(function (r) { return '<tr><td><b>' + r[0] + '</b></td><td>' + r[1] + '</td><td>' + r[2] + '</td><td>' + r[3] + '</td></tr>'; }).join('') +
      '</tbody></table>' + (fit ? '<p class="modal-note"><b>' + KSt('fit_label', 'Dopasowanie:') + '</b> ' + fit + '</p>' : '') + '<p class="modal-note">' + KSt('size_note', 'Wartości orientacyjne — pomiar wkładki w cm jest najpewniejszy.') + '</p></div>';
    document.getElementById('sizeguide-overlay').classList.add('open');
    m.classList.add('open');
  };
  /* ---------- wishlist (ulubione) — snapshot store + szuflada ---------- */
  function ksWishGet() { try { return JSON.parse(localStorage.getItem('ks_wishlist') || '[]'); } catch (e) { return []; } }
  function ksWishSet(a) { try { localStorage.setItem('ks_wishlist', JSON.stringify(a)); } catch (e) {} }
  function ksWishCount() {
    var n = ksWishGet().length, els = document.querySelectorAll('.wish-count');
    for (var i = 0; i < els.length; i++) { els[i].textContent = n; els[i].style.display = n ? '' : 'none'; }
  }
  function ksWishData(b) {
    return { k: b.getAttribute('data-wish-k'), url: b.getAttribute('data-wish-url'), t: b.getAttribute('data-wish-t'),
      b: b.getAttribute('data-wish-b'), c: b.getAttribute('data-wish-c'), img: b.getAttribute('data-wish-img'),
      p: b.getAttribute('data-wish-p'), r: b.getAttribute('data-wish-r') };
  }
  window.KSwishToggle = function (e, btn) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var d = ksWishData(btn), a = ksWishGet(), idx = -1;
    for (var i = 0; i < a.length; i++) { if (a[i].k === d.k) { idx = i; break; } }
    var on; if (idx >= 0) { a.splice(idx, 1); on = false; } else { a.unshift(d); on = true; }
    ksWishSet(a);
    var sel = (window.CSS && CSS.escape) ? CSS.escape(d.k) : d.k;
    var all = document.querySelectorAll('[data-wish-k="' + sel + '"]');
    for (var j = 0; j < all.length; j++) all[j].classList.toggle('on', on);
    ksWishCount();
    var wd = document.getElementById('wish-drawer'); if (wd && wd.classList.contains('open')) ksWishRender();
  };
  function ksWishSync() {
    var keys = {}; ksWishGet().forEach(function (it) { keys[it.k] = 1; });
    var btns = document.querySelectorAll('[data-wish-k]');
    for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('on', !!keys[btns[i].getAttribute('data-wish-k')]);
    ksWishCount();
  }
  function ksWishRender() {
    var d = document.getElementById('wish-drawer'); if (!d) return;
    var a = ksWishGet();
    var rows = a.map(function (it) {
      return '<div class="cart-item"><a class="ci-img" href="' + esc(it.url) + '">' + (it.img ? '<img src="' + esc(it.img) + '" style="width:100%;height:100%;object-fit:contain">' : '') + '</a>' +
        '<div class="ci-info"><a href="' + esc(it.url) + '" style="color:inherit;text-decoration:none"><b>' + esc(it.b || '') + '</b> ' + esc(it.t || '') + '</a>' +
        (it.c ? '<br><span style="color:#888">' + esc(it.c) + '</span>' : '') +
        '<div class="ci-row"><span class="now' + (it.r ? ' sale' : '') + '">' + esc(it.p || '') + '</span>' + (it.r ? ' <s class="oldprice">' + esc(it.r) + '</s>' : '') + '</div>' +
        '<button class="ci-remove" data-wish-k="' + esc(it.k) + '" onclick="KSwishToggle(event,this)">' + KSt('remove', 'Usuń') + '</button></div></div>';
    }).join('');
    d.innerHTML = '<div class="cart-head"><h3>' + KSt('wish_title', 'Ulubione') + ' (' + a.length + ')</h3><button onclick="KSwishClose()">×</button></div>' +
      (a.length ? '<div class="cart-items">' + rows + '</div>'
        : '<div class="cart-empty"><p>' + KSt('wish_empty', 'Brak ulubionych — kliknij serduszko na produkcie.') + '</p><a class="btn btn-grad" href="' + (KS.routes.search || '/search') + '?q=*&type=product" onclick="KSwishClose()">' + KSt('browse', 'Przeglądaj buty') + '</a></div>');
  }
  window.KSwishOpen = function () { ksWishRender(); var d = document.getElementById('wish-drawer'), o = document.getElementById('wish-overlay'); if (d) d.classList.add('open'); if (o) o.classList.add('open'); };
  window.KSwishClose = function () { var d = document.getElementById('wish-drawer'), o = document.getElementById('wish-overlay'); if (d) d.classList.remove('open'); if (o) o.classList.remove('open'); };
  document.addEventListener('DOMContentLoaded', ksWishSync);
  window.KSsizeClose = function () {
    document.getElementById('sizeguide').classList.remove('open');
    document.getElementById('sizeguide-overlay').classList.remove('open');
  };
})();

;(function(){
  window.KSnlClose=function(){var p=document.getElementById('nlpop'),o=document.getElementById('nlpop-overlay');if(p)p.classList.remove('open');if(o)o.classList.remove('open');try{localStorage.setItem('ks_nl','1')}catch(e){}};
  document.addEventListener('DOMContentLoaded',function(){
    try{if(localStorage.getItem('ks_nl'))return}catch(e){}
    setTimeout(function(){var p=document.getElementById('nlpop'),o=document.getElementById('nlpop-overlay');if(p){p.classList.add('open');if(o)o.classList.add('open')}},6000);
  });
})();

;(function(){window.KSgalPick=function(btn,url){var m=document.getElementById('pdp-main-img');if(m)m.src=url;document.querySelectorAll('.pdp-thumb').forEach(function(t){t.classList.remove('active')});btn.classList.add('active')};})();

;(function(){document.addEventListener('DOMContentLoaded',function(){var el=document.getElementById('pdp-delivery');if(!el)return;var loc=(window.KS&&KS.locale)||'pl';function add(n){var d=new Date();var c=0;while(c<n){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)c++;}return d;}function f(d){return d.toLocaleDateString(loc,{day:'numeric',month:'short'});}el.innerHTML=KSt('delivery_estimate','Przewidywana dostawa:')+' <b>'+f(add(3))+' – '+f(add(5))+'</b>';});})();

;(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var box=document.getElementById('pdp-related'); if(!box) return;
    var wrap=document.getElementById('pdp-related-wrap');
    var model=box.getAttribute('data-model'), vendor=box.getAttribute('data-vendor'), pid=parseInt(box.getAttribute('data-pid'),10);
    var seen={}; seen[pid]=1; var out=[];
    function e(s){return (s||'').replace(/[&<>"]/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c];});}
    function card(p){var name=(p.title||'').replace(p.vendor||'','').trim();
      return '<a class="card" href="'+p.url+'"><div class="imgwrap">'+(p.image?'<img src="'+p.image+'" loading="lazy" style="width:100%;height:100%;object-fit:contain">':'')+'</div><div class="meta"><div class="brand">'+e(p.vendor)+'</div><div class="pname">'+e(name)+'</div><div class="price"><span class="now'+(p.onsale?' sale':'')+'">'+e(p.price)+'</span>'+(p.onsale&&p.compare?' <s class="oldprice">'+e(p.compare)+'</s>':'')+'</div></div></a>';}
    function add(list){(list||[]).forEach(function(p){if(p&&!seen[p.id]){seen[p.id]=1;out.push(p);}});}
    function render(){if(out.length){box.innerHTML=out.slice(0,12).map(card).join('');if(wrap)wrap.style.display='';}}
    function q(query){return fetch('/search?q='+encodeURIComponent(query)+'&type=product&view=related&options[prefix]=last').then(function(r){return r.json();}).catch(function(){return [];});}
    q(model).then(function(items){ add(items); render(); if(out.length<6){ q(vendor).then(function(it2){ add(it2); render(); }); } });
  });
})();
